import { Button } from '@/ui-kit/atoms/button';
import { Logo } from '@/ui-kit/atoms/logo';
import { Card } from '@/ui-kit/molecules/card';

export function NoAccessPage({
  upn,
  onSignOut,
}: {
  upn?: string;
  onSignOut: () => void;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <div className="text-center">
          <Logo size="lg" />
        </div>
        <h1 className="mt-6 text-center text-xl font-semibold text-gray-900">
          No access
        </h1>
        <p className="mt-3 text-center text-sm text-gray-600">
          You're signed in as
          <span className="ml-1 font-medium text-gray-900">{upn ?? 'unknown'}</span>
          ,
          but no role has been assigned to your account in this environment.
        </p>
        <p className="mt-2 text-center text-sm text-gray-600">
          Ask an administrator to grant you one of <code>Admin</code>,
          <code className="ml-1">Approver</code>,
          <code className="ml-1">Analyst</code>, or
          <code className="ml-1">Viewer</code> on the commissions app
          registration, then sign back in.
        </p>
        <div className="mt-6 flex justify-center">
          <Button variant="secondary" onClick={onSignOut}>
            Sign out
          </Button>
        </div>
      </Card>
    </div>
  );
}
